import { alpha } from '@mui/material';
const useStartScreenStyles = () => {
    return {
        backgroundAndPreview: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        },
        innerContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
        },
        titleWithLanguageContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        thumbnailContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1
        },
        thumbnail: {
            width: 138.67,
            height: 87,
            borderRadius: 2,
            objectFit: 'cover'
        },
        previewMainContainer: {
            position: 'relative',
            width: '100%',
            minHeight: 250,
            maxHeight: '100%',
            borderRadius: 3,
            bgcolor: (theme) => alpha(theme.palette.common.white, 0.8),
            backdropFilter: 'blur(40px)',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 4
        },
        previewImageContainer: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1
        },
        previewTextEditorContentContainer: {
            bgcolor: (theme) => alpha(theme.palette.common.white, 0.8),
            borderRadius: 3,
            px: 3,
            backdropFilter: 'blur(40px)',
            py: 4.5,
            textAlign: 'center',
            width: '80%',
            maxWidth: 500,
            zIndex: 2,
            gap: 0.5
        }
    };
};
export default useStartScreenStyles;
